import { render, staticRenderFns } from "./RafScoreHistory.vue?vue&type=template&id=012eb148"
import script from "./RafScoreHistory.vue?vue&type=script&lang=ts"
export * from "./RafScoreHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports